import React, { useMemo, useCallback, useContext } from 'react'
import { TextField, makeStyles } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import BreedsContext from '../BreedsContext'

const useStyles = makeStyles((theme) => ({
	root: {},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '.8rem'
		},
		'& .MuiAutocomplete-endAdornment': {
			top: 'calc(50% - 15px)'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	}
}))

const BreedPicker = ({ value, onSelected, label = 'Breed', disabled = false }) => {
	const { breedsContextProvider } = useContext(BreedsContext)
	const classes = useStyles()

	const handleSelection = useCallback(
		(_, value) => {
			if (onSelected) {
				onSelected(value)
			}
		},
		[onSelected]
	)

	const options = useMemo(() => {
		const { breeds } = breedsContextProvider
		if (!breeds) {
			return []
		}

		return Object.keys(breeds)
	}, [breedsContextProvider])

	return (
		<div className={classes.root}>
			<Autocomplete
				disabled={disabled}
				className={classes.autoComplete}
				options={options}
				sx={{ width: 300 }}
				onChange={handleSelection}
				value={value}
				renderInput={(params) => <TextField variant="filled" {...params} label={label} />}
			/>
		</div>
	)
}

export default BreedPicker
